import React, { useEffect, useState } from "react";
import styles from "./teacher-leave-approval.module.css";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import CustomTable from "../../../../common/custom-table/custom-table";
import { Spin } from "antd";
import { getTeacherLeaveApprovalData } from "../../../../services/dashboard";
import StatusChip from "../../../../components/status-chip/status-chip";
import dayjs from "dayjs";
import { DATE_FORMAT, PAGE_LIMIT } from "../../../../constants/common";

const TeacherLeaveApprovalCard = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTeacherLeaveData = async () => {
    setLoading(true);
    try {
      const payload = {
        page: 1,
        pageSize: PAGE_LIMIT,
      };
      const response = await getTeacherLeaveApprovalData(payload);
      const responceData = response.data || [];
      setTableData(responceData?.data);
    } catch (error) {
      console.error("Error fetching upcoming examinations data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTableData([]);
    getTeacherLeaveData();
  }, []);

  const columns = [
    {
      title: "Teacher Name",
      dataIndex: "teacher_name",
      key: "teacher_name",
      sorter: (a, b) => a.teacher_name.localeCompare(b.teacher_name),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      sorter: (a, b) => a.department.localeCompare(b.department),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Leave Type",
      dataIndex: "leave_type",
      key: "leave_type",
      sorter: (a, b) => a.leave_type.localeCompare(b.leave_type),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: (a, b) => a.start_date.localeCompare(b.start_date),

      render: (text) => (
        <span style={{ cursor: "pointer" }}>
          {dayjs(text).format(DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY)}
        </span>
      ),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: (a, b) => a.end_date.localeCompare(b.end_date),
      render: (text) => (
        <span style={{ cursor: "pointer" }}>
          {dayjs(text).format(DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY)}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (text) => (
        <StatusChip
          status={text?.toLowerCase() === "approved" ? "active" : "inactive"}
        />
      ),
    },
  ];

  return (
    <CustomCard style={{ height: 270 }}>
   
      <div className={styles.topBar}>
        <span className={styles.card_heading}>Teacher Leaves & Approvals</span>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>
    
      <div className={styles.tableWrapper}>
        <Spin spinning={loading}>
          <CustomTable
            columns={columns}
            dataSource={tableData}
            pagination={false}
            scroll={{ x: 800 }} 
          />
        </Spin>
      </div>
    </CustomCard>
  );
};

export default TeacherLeaveApprovalCard;
